import React, { useEffect, useRef, useState } from "react";

import Header from "../../components/partials/Header";
import { Link } from "react-router-dom";
import Footer from "../../components/partials/Footer";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from 'swiper/react';
import {Autoplay} from 'swiper/modules'

// Import Swiper styles
import 'swiper/css';

export default function Home() {
  return (
    <main>
      <Header />

      <HomePage />

      <Footer />
    </main>
  );
}


const HomePage = () => {
  const { i18n, t } = useTranslation();
  
  return (
    <>
      <section>

        <div className="home_wrapper">
          <div className="home_left_area">
            <div className="mini_cube_item mini_cube_green">
              <img src="/assets/images/mini_cube_green.png" alt="" />
            </div>
            <div className="mini_cube_item mini_cube_blue">
              <img src="/assets/images/mini_cube_blue.png" alt="" />
            </div>
          </div>
          <div className="home_right_area">
            <div className="love_mini_cube">
              <img src="/assets/images/love_mini_cube.png" alt="" />
            </div>
            <div className="mini_cube_skateboard">
              <h1>{t("for_kids")}</h1>
              <p>{t("and_much_more")}</p>
              <img src="/assets/images/mini_cube_skateboard.png"  alt="" />
            </div>
          </div>
        </div>

        <div className="store_wrapper">
          <h1>{t('find_us')}</h1>  
          <div className="stores">
            <Swiper
              slidesPerView={9}
              spaceBetween={60}
              loop={true}
              speed={3000}
              autoplay={{
                delay: 10,
              }}
              pagination={{
                clickable: true,
              }}
              modules={[Autoplay]}
              breakpoints={{
                320: {
                  slidesPerView: 5,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 6,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 9,
                  spaceBetween: 60,
                },
              }}
              className="mySwiper"
            >
              <SwiperSlide className="store_item">
                <img src="/assets/images/spari.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/fresco.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/nikora.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/magniti.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/goodwill.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/europroduct.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/universami.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/daily.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/gvirila.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/spari.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/fresco.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/nikora.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/magniti.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/goodwill.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/europroduct.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/universami.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/daily.png" alt="" />
              </SwiperSlide>
              <SwiperSlide className="store_item">
                <img src="/assets/images/gvirila.png" alt="" />
              </SwiperSlide>
            </Swiper>
            
          </div>
        </div>
      </section>
      <section id="about_us">
        <div className="yellow_cloud"></div>

        <div className="about_wrapper">
          <div className="about_left_area">
            <h1>{t('about_us')}</h1>  
            <p className="about_text">
            {t("text1")} <span className="f-bold">{t("text2")} </span> {t("text3")}  <span className="f-bold">{t("text4")} </span>
            </p>
            <p className="about_text">
              <li>
                <img src="/assets/images/verification.png" alt="" /> {t("text5")}  {t("text6")}
              </li>
              <li>
                <img src="/assets/images/lolipop.png" alt="" /> {t("text7")} {t("text8")}
              </li>
              <li>
                <img src="/assets/images/goot_heart.png" alt="" /> {t("text9")}
              </li>
            </p>
            <p className="about_text">
              <span className="f-bold">{t("text10")} </span> <br />{t("text11")}
            </p>
            <p className="about_text f-bold">{t("text12")}</p>
          </div>          
          <div className="about_right_area">
            <img src="/assets/images/mini_cubes_stack.png" alt="" />  
          </div>          
        </div>

        <div className="about_wrapper_sm">
          <div className="about_left_area">
            <h1>{t('about_us')}</h1>  
            <p className="about_text">
              {t("text1")} <span className="f-bold">{t("text2")} </span> {t("text3")}  <span className="f-bold">{t("text4")} </span>
            </p>
            <div className="about_text_flex">
              <p className="about_text">
                <li>
                  <img src="/assets/images/verification.png" alt="" /> <p> <span className="f-bold">{t("text5")} </span>{t("text6")} </p>
                </li>
                <li>
                  <img src="/assets/images/lolipop.png" alt="" /> <p> <span className="f-bold">{t("text7")} </span>{t("text8")} </p>
                </li>
                <li>
                  <img src="/assets/images/goot_heart.png" alt="" /> <p>{t("text9")}  </p>
                </li>
              </p>
              <img src="/assets/images/mini_cubes_stack.png" alt="" />  
            </div>
            <p className="about_text">
              <span className="f-bold">{t("text10")} </span> <br />{t("text11")} 
            </p>
            <p className="about_text f-bold">{t("text12")} </p>
          </div>          
        </div>

        <div className="yellow_cloud reverse_cloud"></div>

      </section>
    </>
  )

}